<template>
  <div>
    <div class="sixteentosix omt-6 omt-md-25">
      <div
        class="kachelimage header-image"
        style="background: url('/static/img/meeting_old.jpg')"
      >
        <div class="headline">
          <div class="text-subtitle-2 text-md-h5">{{ $t("sales list") }}</div>
        </div>
      </div>
    </div>
    <div class="sl_list">
      <div class="col-xl-12 col-md-12 pa-0">
        <div class="border m-5 border-dark border-5">
          <b>Trends By The Months</b>
          <BarChartKB
            :chart-labels="trendbymonthlabels"
            :chart-datasets="trendbymonthdatasets"
            :chart-id="trendbymonthchartId"
            :dataset-id-key="trendbymonthdatasetIdKey"
            :plugins="trendbymonthplugins"
            :css-classes="trendbymonthcssClasses"
            :styles="trendbymonthstyles"
            :width="trendbymonthwidth"
            :height="trendbymonthheight"
          />
        </div>
        <div class="border m-5 border-dark border-5">
          <b>Evaluation of the feedback forms October 2023</b>
          <LineChartKB
            :chart-labels="labelsevaluationfeedback"
            :chart-datasets="datasetsevaluationfeedback"
          />
        </div>
        <div class="row m-5">
          <div class="col-6 border border-dark border-5">
            <b>Average Grade Training Preparation</b>
            <LineChartKB
              :chart-labels="labelstrainingpreparation"
              :chart-datasets="datasetstrainingpreparation"
            />
          </div>
          <div class="col-6 border border-dark border-5">
            <b>Average Grade Training Delivery</b>
            <LineChartKB
              :chart-labels="labelstrainingdelivery"
              :chart-datasets="datasetstrainingdelivery"
            />
          </div>
        </div>
        <div class="row m-5">
          <div class="col-6 border border-dark border-5">
            <b>Average Grade Training Room</b>
            <LineChartKB
              :chart-labels="labelstrainingroom"
              :chart-datasets="datasetstrainingroom"
            />
          </div>
          <div class="col-6 border border-dark border-5">
            <b>Average Grade Training Conclusion</b>
            <LineChartKB
              :chart-labels="labelstrainingconclusion"
              :chart-datasets="datasetstrainingconclusion"
            />
          </div>
        </div>
        <div class="row m-5">
          <div class="col-6 border border-dark border-5">
            <b>Average Grade Training Structure</b>
            <LineChartKB
              :chart-labels="labelstrainingstructure"
              :chart-datasets="datasetstrainingstructure"
            />
          </div>
          <div class="col-6 border border-dark border-5">
            <b>Average Grade Of each Individual Training</b>
            <LineChartKB
              :chart-labels="labelstrainingindividual"
              :chart-datasets="datasetstrainingindividual"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      trendbymonthchartId: "custom-chart-id",
      trendbymonthdatasetIdKey: "label",
      trendbymonthplugins: [],
      trendbymonthcssClasses: "custom-chart-classes",
      trendbymonthstyles: {},
      trendbymonthwidth: 500,
      trendbymonthheight: 300,
      trendbymonthlabels: [
        "Jan, 44 Feedback Forms",
        "Feb, 22 Feedback Forms",
        "Mar, 30 Feedback Forms",
        "Apr, 50 Feedback Forms",
        "May, 35 Feedback Forms",
        "Jun, 28 Feedback Forms",
        "Jul, 42 Feedback Forms",
        "Aug, 37 Feedback Forms",
        "Sep, 48 Feedback Forms",
        "Oct, 25 Feedback Forms",
        "Nov, 60 Feedback Forms",
        "Dec, 55 Feedback Forms",
      ],
      trendbymonthdatasets: [
        {
          label: "FeedBack Forms",
          backgroundColor: "#4473c5",
          data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11],
        },
      ],
      labelsevaluationfeedback: [
        "Recommend",
        "Use for",
        "Learning",
        "Content",
        "Trainer",
        "Recommend",
        "Use for",
        "Learning",
        "Recommend",
        "Use for",
        "Learning",
        "Content",
        "Trainer",
        "Recommend",
        "Use for",
        "Learning",
      ],
      datasetsevaluationfeedback: [
        {
          label: "Evaluation of the feedback forms October 2023",
          backgroundColor: "#000000",
          data: [0, 2, 3, 4, 5, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
        },
      ],
      labelstrainingpreparation: [
        "Vorg_712_Lint_03",
        "Vorg_713_Lint_03",
        "Vorg_714_Lint_03",
      ],
      datasetstrainingpreparation: [
        {
          label: "Average Grade Training Preparation",
          backgroundColor: "#000000",
          data: [0, 1, 2, 3, 4, 5, 6],
        },
      ],
      labelstrainingdelivery: [
        "Vorg_712_Lint_03",
        "Vorg_713_Lint_03",
        "Vorg_714_Lint_03",
      ],
      datasetstrainingdelivery: [
        {
          label: "Average Grade Training Delivery",
          backgroundColor: "#000000",
          data: [0, 1, 2, 3, 4, 5, 6],
        },
      ],
      labelstrainingroom: [
        "Vorg_712_Lint_03",
        "Vorg_713_Lint_03",
        "Vorg_714_Lint_03",
      ],
      datasetstrainingroom: [
        {
          label: "Average Grade Training Room",
          backgroundColor: "#000000",
          data: [5, 4, 3, 2, 1, 0, 6],
        },
      ],
      labelstrainingconclusion: [
        "Vorg_712_Lint_03",
        "Vorg_713_Lint_03",
        "Vorg_714_Lint_03",
      ],
      datasetstrainingconclusion: [
        {
          label: "Average Grade Training Conclusion",
          backgroundColor: "#000000",
          data: [6, 5, 4, 3, 2, 1, 0],
        },
      ],
      labelstrainingstructure: [
        "Vorg_712_Lint_03",
        "Vorg_713_Lint_03",
        "Vorg_714_Lint_03",
      ],
      datasetstrainingstructure: [
        {
          label: "Average Grade Training Structure",
          backgroundColor: "#000000",
          data: [0, 1, 2, 3, 6, 5, 4],
        },
      ],
      labelstrainingindividual: [
        "Vorg_712_Lint_03",
        "Vorg_713_Lint_03",
        "Vorg_714_Lint_03",
      ],
      datasetstrainingindividual: [
        {
          label: "Average Grade Of each Individual Training",
          backgroundColor: "#000000",
          data: [6, 5, 4, 3, 2, 1, 0],
        },
      ],
    };
  },
};
</script>
